import React, { useEffect, useState } from 'react';
import { routes as ROUTES } from 'constants/config';
import { Spinner } from 'ui';
import request from 'utils/request_ajax';
import cn from 'classnames';
import { contentTableHeaders } from '../../constants/tableHeaders';
import JourneyTableBody from './Journeys/JourneyTableBody';
import Table from '../shared/table/Table.jsx';
import IndexTableHeader from '../shared/index/table/header';

const JourneysContent = ({ query, filterUpdateQuery }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    request
      .get(ROUTES.JOURNEY.GET)
      .then(responseData => {
        setData(responseData.journeys);
        setLoading(false);
      })
      .fail(err => {
        console.error(err);
      });
  }, []);

  return (
    <>
      {loading ? (
        <div className="JourneysContent-loader">
          <div>
            <Spinner />
            <span className="ml-8 c-brand-gray-darker">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <Table
            className={cn(
              'Index-table',
              'trk_container_readiness_content-list',
            )}
            role="table"
            alternate
            noBorderTop
            roundedBottom
          >
            <IndexTableHeader
              selectable={false}
              clickable={false}
              tableHeaders={contentTableHeaders.journeys}
            />
            <JourneyTableBody data={data} />
          </Table>
        </>
      )}
    </>
  );
};

export default JourneysContent;
